import emailSpellChecker, {
  POPULAR_DOMAINS,
  POPULAR_TLDS,
} from '@zootools/email-spell-checker'

/**
 * Major international providers missing from the library's built-in list.
 */
const MISSING_INTERNATIONAL = [
  'hotmail.com',
  'outlook.com',
  'yahoo.com',
  'live.com',
  'mac.com',
]

/**
 * Popular Finnish email domains sourced from markku_db_prod (2026-03).
 *
 * Refresh with:
 * SELECT SPLIT_PART(email, '@', 2) AS domain, COUNT(*) AS count
 * FROM users WHERE deleted_at IS NULL GROUP BY domain ORDER BY count DESC;
 */
const FINNISH_DOMAINS = [
  // ISP / telecom (>10 users)
  'kolumbus.fi',
  'elisanet.fi',
  'saunalahti.fi',
  'pp.inet.fi',
  'welho.com',
  'phnet.fi',
  // Finnish email services
  'iki.fi',
  'luukku.com',
  'netti.fi',
  'kotikone.fi',
  'fimnet.fi',
  'sci.fi',
  'kotiposti.net',
  'kotiportti.fi',
  'nic.fi',
  'suomi24.fi',
  'jippii.fi',
  'surffi.fi',
  'wippies.fi',
  'pp1.inet.fi',
  'dlc.fi',
  // Finnish variants of international providers
  'hotmail.fi',
  'live.fi',
  'yahoo.fi',
  'windowslive.com',
]

const FINNISH_TLDS = ['ax']

const ALL_DOMAINS = [
  ...POPULAR_DOMAINS,
  ...MISSING_INTERNATIONAL,
  ...FINNISH_DOMAINS,
]
const ALL_TLDS = [...POPULAR_TLDS, ...FINNISH_TLDS]

export interface EmailSuggestion {
  address: string
  domain: string
  full: string
}

/**
 * Checks an email address for likely domain typos and returns a suggestion.
 * Returns `undefined` if no typo is detected.
 *
 * @example
 * checkEmailSuggestion('user@gmai.com')
 * // => { address: 'user', domain: 'gmail.com', full: 'user@gmail.com' }
 */
export function checkEmailSuggestion(
  email: string,
): EmailSuggestion | undefined {
  if (!email?.includes('@')) return undefined

  return emailSpellChecker.run({
    email,
    domains: ALL_DOMAINS,
    topLevelDomains: ALL_TLDS,
  }) as EmailSuggestion | undefined
}
